import CrudAPI from '@/api/resources/crud'

const checklistsAPI = {
  // specific checklists api
  resource: 'checklists',
  url_query: '/api/checklists',

  delete (itemId) {
    return new Promise((resolve, reject) => {
      let result = CrudAPI.dfsResourceDestroy(this.resource, itemId)

      result.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  add (itemsIds, itemType, question, casesId = null) {
    return new Promise((resolve, reject) => {
      let payload = {
        items_ids: itemsIds,
        item_type: itemType,
        cases_id: casesId,
        question: question
      }

      let result = CrudAPI.dfsResourceStore(this.resource, payload)

      result.then(result => {
        resolve(result.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  editQuestion (itemId, question) {
    return new Promise((resolve, reject) => {
      let payload = {
        question: question
      }

      let result = CrudAPI.dfsResourceUpdate(this.resource, itemId, payload)

      result.then(result => {
        resolve(result.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  setCheckListStatus (itemId, status) {
    return new Promise((resolve, reject) => {
      let payload = {
        is_complete: status
      }

      let result = CrudAPI.dfsResourceUpdate(this.resource, itemId, payload, '/completition')

      result.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  }
}

export default checklistsAPI



// WEBPACK FOOTER //
// ./src/api/resources/checklists.js